import { __decorate, __metadata, __param } from "tslib";
import { Directive, Inject, Input } from 'angular-ts-decorators';
var SystemDictionaryDirective = (function () {
    function SystemDictionaryDirective($element, translation) {
        this.$element = $element;
        this.translation = translation;
        this.systemDictionary = '';
    }
    SystemDictionaryDirective.prototype.ngOnInit = function () {
        var value = this.translation.getSystem(this.systemDictionary);
        this.$element.find('*').not('.material-icons-outlined').remove();
        this.$element.append(value);
    };
    SystemDictionaryDirective.$inject = ['$element', 'translation'];
    __decorate([
        Input('@'),
        __metadata("design:type", Object)
    ], SystemDictionaryDirective.prototype, "systemDictionary", void 0);
    SystemDictionaryDirective = __decorate([
        Directive({
            selector: '[systemDictionary]',
        }),
        __param(0, Inject('$element')),
        __param(1, Inject('translation')),
        __metadata("design:paramtypes", [Object, Object])
    ], SystemDictionaryDirective);
    return SystemDictionaryDirective;
}());
export { SystemDictionaryDirective };
